import React, { createContext, useContext } from 'react';
import { VERSION, VERSIONS } from '../../../../constants';

interface AppContext {
  version: VERSION;
}

const appContext = createContext<AppContext>({
  version: VERSIONS.FALLBACK,
});

interface AppContextProps {
  version: VERSION;
  children: React.ReactNode;
}

export const AppContext = (props: AppContextProps) => {
  const { version, children } = props;

  const context = {
    version,
  };

  return <appContext.Provider value={context}>{children}</appContext.Provider>;
};

export const useAppContext = () => useContext(appContext);
